import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { takePostAuthRedirect } from '../utils/auth';
import '../styles/auth.css';

export default function VerifyEmail() {
  const { token } = useParams();
  const navigate = useNavigate();
  const ranRef = useRef(false);
  const [state, setState] = useState({ status: 'verifying', message: '' });

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;
    (async () => {
      try {
        const { data } = await axios.post('/api/auth/verify-email', { token });
        if (data?.token) localStorage.setItem('adeeb-token', data.token);
        if (data?.user) localStorage.setItem('adeeb-user', JSON.stringify(data.user));
        window.dispatchEvent(new Event('adeeb-auth-change'));
        setState({ status: 'success', message: 'Your email is verified. Welcome to Deenlit!' });
        const destination = takePostAuthRedirect() || '/';
        setTimeout(() => navigate(destination, { replace: true }), 1500);
      } catch (err) {
        setState({
          status: 'error',
          message: err?.response?.data?.message || 'Verification failed.',
        });
      }
    })();
  }, [token, navigate]);

  return (
    <div className="auth-wrapper">
      <Link to="/" className="floating-back-btn">&#8592; Library</Link>
      <div className="auth-bg-ornament" aria-hidden="true">&#10040; &#10040; &#10040;</div>
      <div className="auth-card">
        <Link to="/" className="auth-logo"><img className="auth-brand-image" src="/branding/deenlit-logo.png" alt="DeenLit" width="2172" height="724" /></Link>
        <p className="auth-tagline">Email verification</p>
        {state.status === 'verifying' && (
          <p style={{ textAlign: 'center', marginTop: 16 }}>Verifying your email…</p>
        )}
        {state.status === 'success' && (
          <div className="auth-success" role="status" style={{ marginTop: 16 }}>
            {state.message}
          </div>
        )}
        {state.status === 'error' && (
          <>
            <div className="auth-error" role="alert" style={{ marginTop: 16 }}>
              {state.message}
            </div>
            <Link to="/verify-pending" className="auth-submit" style={{ marginTop: 16, textAlign: 'center' }}>
              Request a new link
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
